import { Component, OnInit } from '@angular/core'
import { _HttpClient } from '@delon/theme'
import { environment } from '@env/environment'
import { interval, mergeMap } from 'rxjs'
const { msUrl } = environment.api

@Component({
  selector: 'header-notify',
  template: `
    <header-notify-content
      [count]="count"
      [records]="records"
      (callbackEvent)="refreshData($event)"
    />
  `,
})
export class HeaderNotifyComponent implements OnInit {
  records: any = []
  count = 0

  constructor(private http: _HttpClient) {}

  refreshData(obj = {}): void {
    this.http.get(`${msUrl.auth}/station_messages/my?mark=0`).subscribe((res: any) => {
      if (res.successful) {
        const { data } = res
        const { records } = data
        this.count = records.length
        this.records = records
      }
    })
  }

  ngOnInit(): void {
    this.refreshData()
    interval(1000 * 60 * 10)
      .pipe(mergeMap((x) => this.http.get(`${msUrl.auth}/station_messages/my?mark=0`)))
      .subscribe((res: any) => {
        if (res.successful) {
          const { data } = res
          const { records } = data
          this.count = records.length
          this.records = records
        }
      })
  }
}
